import { createSelector } from '@reduxjs/toolkit';
export const facetResponseSelector = createSelector((state, facetId) => ({ state, facetId }), ({ state, facetId }) => {
    const facetResponse = state.commerceSearch.facets.find((facetResponse) => facetResponse.facetId === facetId);
    if (facetResponse && facetResponse.facetId in state.commerceFacetSet) {
        return facetResponse;
    }
    return undefined;
});
export const isFacetLoadingResponseSelector = createSelector((state) => ({ state }), ({ state }) => state.commerceSearch.isLoading);
